import { validateSurveyPeriod } from "./surveyUtils";

export const prepareInternalContent = async (input: any) => {
  const content = { version: 2, modules: [], transmissions: [], recordings: [], materials: [], announcements: [], ...input };
  const modules = (content.modules || []).map((module: any, moduleIndex: number) => ({
    ...module,
    id: module.id || crypto.randomUUID(),
    order: Number.isFinite(module.order) ? module.order : moduleIndex,
    items: (module.items || []).map((item: any, itemIndex: number) => ({
      ...item,
      id: item.id || crypto.randomUUID(),
      order: Number.isFinite(item.order) ? item.order : itemIndex,
      completionMode: item.completionMode || "NONE",
    })),
  }));
  const sessions = await Promise.all((content.attendance?.sessions || []).map(async (session: any) => {
    const id = session.id || crypto.randomUUID();
    let codeHash = session.codeHash;
    if (session.methods?.includes("CODE") && session.code) {
      const bytes = new TextEncoder().encode(String(session.code).trim().toUpperCase());
      codeHash = [...new Uint8Array(await crypto.subtle.digest("SHA-256", bytes))].map((x) => x.toString(16).padStart(2, "0")).join("");
    }
    const { code, ...safe } = session;
    return { ...safe, id, codeHash };
  }));
  const certificate = content.certificate
    ? { ...content.certificate, template: "INSTITUTIONAL", orientation: "LANDSCAPE" }
    : undefined;
  const validSurvey = validateSurveyPeriod(content.survey);
  const survey = validSurvey ? {
    ...validSurvey,
    questions: (validSurvey.questions || []).map((question: any, index: number) => ({
      ...question,
      id: question.id || crypto.randomUUID(),
      order: index,
      active: question.active !== false,
      options: ["SINGLE_CHOICE", "MULTIPLE_CHOICE"].includes(question.type)
        ? [...new Set((question.options || []).map((option: any) => String(option).trim()).filter(Boolean))]
        : [],
    })),
  } : undefined;
  return { ...content, version: 2, modules, attendance: content.attendance ? { ...content.attendance, sessions } : undefined, certificate, survey };
};
